// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: "Kanit";
}

.refreshButton {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
    text-align: center;
    padding: 2px 10px 0px 10px;
    z-index: 1;
    background-color: rgb(255, 255, 255, 0.8);
    border: 0px;
    border-radius: 8px;
    opacity: 1;
    width: auto;
    height: 30px;
}

.search-location {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
    display: flex;
    position: absolute;
    text-align: center;
    top: 80px;
    left: 60px;
    padding: 10px;
    z-index: 400;
    background-color: rgb(255, 255, 255, 0.9);
    width: auto;
    height: auto;
    border: 0px;
    border-radius: 24px;
}

/* .draggable {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
   min-width: 175px;
   height: 400px;
    cursor: grab;
    background-color: #f1f1f1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    z-index: 400;
    position: absolute;
    border: 0px;
    border-radius: 10px;
 } */
.close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 30px;
    color: #868686;

}

.close-button:hover {
    color: #0077B6;
    opacity: 0.85;
}

.bottomBar-main {
    padding: 20px;
    width: 100%;
    height: 45vh;
    background-color: rgb(255, 255, 255, 0.95);
    z-index: 400;
    position: absolute;
    bottom: -10vh;
    /* Define animation */
    animation-name: slideTop;
    animation-duration: 0.7s;
    animation-timing-function: ease-in-out;
}

.weather-card-container {
    margin: 0px 0px 0px 0px;
    cursor: pointer;
    position: fixed;
    bottom: 10px;
    right: -30px;
    background-color: rgb(255, 255, 255);
    padding: 10px 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 100;
}

.icon-card-map {
    border: 2px solid rgba(0, 0, 0, 0.4);
    background-clip: padding-box;
    background: #fff;
    border-radius: 5px;
    box-shadow: none;
    cursor: pointer;
    font-family: "Kanit";

}

.icon-weather {
    width: 44px;
    height: 44px;
    color: #868686;
    transition: 0.5s;
}

.icon-weather:hover {
    transform: scale(0.8);
    transition: 0.5s;
    color: #0077B6;
    opacity: 0.9;
}

div[class^="grid-container-"] {
    display: grid;
    grid-gap: 1px 10px;

}

div[class^="grid-container-"] .grid-item {
    padding: 15px 0px;
}

div[class^="grid-container-"] .grid-item:hover {
    background-color: rgba(134, 134, 134, 0.3);
    transition: 0.5s;
}

div.weather {
    text-align: center;
    border-radius: 25px;
    transition: 0.5s;
}

div.weather-selected {
    text-align: center;
    border-radius: 25px;
    background-color: rgba(134, 134, 134, 0.15);
    transition: 0.5s;
}

.grid-container-3 {
    grid-template-columns: repeat(3, 1fr);
}

.grid-container-4 {
    grid-template-columns: repeat(4, 1fr);
}

.grid-container-5 {
    grid-template-columns: repeat(5, 1fr);
}

.grid-container-6 {
    grid-template-columns: repeat(6, 15.5%);
}

.grid-container-7 {
    grid-template-columns: repeat(7, 13%);
}

.custom-slider-container {
    position: relative;
}

.custom-slider-container {
    position: relative;
}

.marks-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -5px;
    /* Adjust as needed */
    display: flex;
    margin-left: 10px;
    margin-right: 5px;
    gap: 18px;
}

div[class^="compass-arrow-"] .grid-item {
    padding: 15px 0px;
}

div.compass-container {
    justify-content: center;
    display: flex;
    width: 64px;
    height: 64px;
    padding: 10px 0px;
}

.compass-arrow {
    justify-content: center;
    align-items: center;
    display: flex;
    width: 40px;
    height: 40px;
    color: #0077B6;
    animation: compass-arrow 2s linear infinite;
}

/* icon static 45deg FaLocationArrow*/
.N {
    --start-angle: -45deg;
    animation: move-arrow-compass 6s linear infinite;
}

.NNE {
    --start-angle: -22.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.NE {
    --start-angle: 0deg;
    animation: move-arrow-compass 6s linear infinite;
}

.ENE {
    transform: rotate(22.5deg);
    --start-angle: 22.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.E {
    --start-angle: 45deg;
    animation: move-arrow-compass 6s linear infinite;
}

.ESE {
    --start-angle: 67.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.SE {
    --start-angle: 90deg;
    animation: move-arrow-compass 6s linear infinite;
}

.SSE {
    --start-angle: 112.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.S {
    --start-angle: 135deg;
    animation: move-arrow-compass 6s linear infinite;
}

.SSW {
    --start-angle: 157.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.SW {
    --start-angle: 180deg;
    animation: move-arrow-compass 6s linear infinite;
}

.WSW {
    --start-angle: 202.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.W {
    --start-angle: 225deg;
    animation: move-arrow-compass 6s linear infinite;
}

.WSW {
    --start-angle: 247.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

.NW {
    --start-angle: 270deg;
    animation: move-arrow-compass 6s linear infinite;
}

.NNW {
    --start-angle: 292.5deg;
    animation: move-arrow-compass 6s linear infinite;
}

@keyframes move-arrow-compass {

    0%,
    50%,
    100% {
        transform: rotate(var(--start-angle));
    }

    25% {
        transform: rotate(calc(var(--start-angle) - 10deg));
    }

    75% {
        transform: rotate(calc(var(--start-angle) + 10deg));
    }
}


.dots-container {
    padding: 0;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 100%;
}

.dots {
    animation: bounce 1.5s infinite linear;
    background: #0077B6;
    border-radius: 50%;
    display: inline-block;
    height: 15px;
    text-align: center;
    width: 15px;
    margin: 5px;

}

.dots:nth-child(1) {
    animation-delay: .2s;
}

.dots:nth-child(2) {
    animation-delay: .4s;
}

.dots:nth-child(3) {
    animation-delay: .6s;
}

.dots:nth-child(4) {
    animation-delay: .8s;
}

.dots:nth-child(5) {
    animation-delay: 1s;
}

@keyframes bounce {
    0% {
        transform: translateY(0);
    }

    15% {
        transform: translateY(-15px);
    }

    30% {
        transform: translateY(0);
    }
}


.search-show-val {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
    display: inline-block;
    position: absolute;
    text-align: start;
    top: 146px;
    left: 60px;
    padding: 10px;
    z-index: 400;
    background-color: rgb(255, 255, 255, 0.9);
    width: 320.5px;
    height: auto;
    border: 0px;
    border-radius: 0px 0px 10px 10px;
}

.searching-val {
    padding: 3%;
}

.searching-val:hover {
    opacity: 0.8;
    background-color: rgba(197, 197, 197, 0.8);
    ;
}

.sidebar-main {
    width: 400px;
    height: 100vh;
    background-color: rgb(255, 255, 255, 0.95);
    z-index: 400;
    position: absolute;
    top: 85px;
    /* Define animation */
    animation-name: slideIn;
    animation-duration: 0.7s;
    animation-timing-function: ease-in-out;
}

@keyframes slideTop {
    from {
        transform: translateY(50vh);
    }

    to {
        transform: translateY(0);
    }
}

@keyframes slideIn {
    from {
        transform: translateX(-500px);
    }

    to {
        transform: translateX(0);
    }
}

.sidebar-header {
    background-color: rgb(255, 255, 255, 0.95);
    padding: 5% 5% 5px 5%;
    display: flex;
    text-align: center;
    width: 100%;
    color: #0077B6;
    border-bottom: 2px solid #555;
}

.sidebar-section {

    border-top: 2px solid rgb(0, 150, 199, 0.4);
    display: flex;
    justify-items: center;
}


.icon-pointer {
    display: flex;
    justify-content: center;
    margin: auto;
}

.icon-pointer:hover {
    cursor: pointer;
    opacity: 0.7;
}

.search-input {
    height: 30px;
    margin: auto;
    margin-left: 15px;
    border: none;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 15px;
    padding: 5px 10px 5px 15px;
}

.search-input:hover {
    background-color: rgb(0, 150, 199, 0.4)
}

.search-input:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.7);
}

.toNav-btn {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
    position: absolute;
    text-align: center;
    align-items: center;
    padding: 2px 10px 0px 10px;
    z-index: 1;
    background-color: rgb(255, 255, 255, 0.9);
    opacity: 1;
    height: 20px;
    width: 60px;
    left: 50%;
}

.toNavSide-btn {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
    position: absolute;
    text-align: end;
    align-items: center;
    /* padding:2px 10px 0px 10px; */
    z-index: 1;
    background-color: rgb(255, 255, 255, 0.9);
    opacity: 1;
    height: 70px;
    width: 25px;
    /* Define animation */
    animation-name: slideIn;
    animation-duration: 0.7s;
    animation-timing-function: ease-in-out;
}

.sidebar-date-box {
    background-color: white;
    border-radius: 2%;
    width: 350px;
}

.sidebar-wrapper {
    display: flex;
    justify-items: center;
    padding: 3% 1%;
    margin: auto;
    height: 100%;
    width: 100%;
}

.sidebar-card {
    margin-left: 5px;
    vertical-align: baseline;
    width: 380px;
    height: auto;
    max-width: 380px;
    padding: 20px 15px;
    min-inline-size: auto;
    background-color: rgba(216, 216, 216, 0.658);
    border-radius: 10px;
    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.12);
}

.sidebar-card-title {
    position: relative;
}

.sidebar-card-body {
    height: auto;
    overflow: auto;
}

.sidebox-remark {
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
    display: flex;
    position: absolute;
    text-align: center;
    margin-top: 15px;
    left: 430px;
    width: 500px;
    height: auto;
    padding: 20px 15px;
    min-inline-size: auto;
    background-color: rgba(216, 216, 216, 0.92);
    border-radius: 6px;
    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.12);
}

.remark-details {
    text-align: start;
}

.close-btn {
    cursor: pointer;
    float: left;
    font-size: 20px;
}

.selection-Date {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.selection-Time {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 15px 0px;
}

p.datafeatures {
    cursor: pointer;
}

p.datafeatures:hover {
    color: gray;
}

p.datafeatures:focus {
    color: #0077B6;
}

.leaflet-popup-content {
    text-align: start;
    font-size: 12.5px;
}

.leaflet-popup-tip {
    display: none;
}

#latlonSelect {
    color: "red";
}

.nav-link-test {
    padding: 0 !important;
}

.custom-nav-dropdown .dropdown-menu {
    padding: 0;
}

.custom-nav-dropdown .nav-link {
    padding: 0;
}

/* btn image CheckMark animation */
.success-checkmark {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;

    .check-icon {
        width: 80px;
        height: 80px;
        position: relative;
        border-radius: 50%;
        box-sizing: content-box;
        border: 4px solid #4CAF50;

        &::before {
            top: 3px;
            left: -2px;
            width: 30px;
            transform-origin: 100% 50%;
            border-radius: 100px 0 0 100px;
        }

        &::after {
            top: 0;
            left: 30px;
            width: 60px;
            transform-origin: 0 50%;
            border-radius: 0 100px 100px 0;
            animation: rotate-circle 4.25s ease-in;
        }

        &::before,
        &::after {
            content: '';
            height: 100px;
            position: absolute;
            background: #FFFFFF;
            transform: rotate(-45deg);
        }

        .icon-line {
            height: 5px;
            background-color: #4CAF50;
            display: block;
            border-radius: 2px;
            position: absolute;
            z-index: 10;

            &.line-tip {
                top: 46px;
                left: 14px;
                width: 25px;
                transform: rotate(45deg);
                animation: icon-line-tip 0.75s;
            }

            &.line-long {
                top: 38px;
                right: 8px;
                width: 47px;
                transform: rotate(-45deg);
                animation: icon-line-long 0.75s;
            }
        }

        .icon-circle {
            top: -4px;
            left: -4px;
            z-index: 10;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            position: absolute;
            box-sizing: content-box;
            border: 4px solid rgba(76, 175, 80, .5);
        }

        .icon-fix {
            top: 8px;
            width: 5px;
            left: 26px;
            z-index: 1;
            height: 85px;
            position: absolute;
            transform: rotate(-45deg);
            background-color: #FFFFFF;
        }
    }
}

@keyframes rotate-circle {
    0% {
        transform: rotate(-45deg);
    }

    5% {
        transform: rotate(-45deg);
    }

    12% {
        transform: rotate(-405deg);
    }

    100% {
        transform: rotate(-405deg);
    }
}

@keyframes icon-line-tip {
    0% {
        width: 0;
        left: 1px;
        top: 19px;
    }

    54% {
        width: 0;
        left: 1px;
        top: 19px;
    }

    70% {
        width: 50px;
        left: -8px;
        top: 37px;
    }

    84% {
        width: 17px;
        left: 21px;
        top: 48px;
    }

    100% {
        width: 25px;
        left: 14px;
        top: 45px;
    }
}

@keyframes icon-line-long {
    0% {
        width: 0;
        right: 46px;
        top: 54px;
    }

    65% {
        width: 0;
        right: 46px;
        top: 54px;
    }

    84% {
        width: 55px;
        right: 0px;
        top: 35px;
    }

    100% {
        width: 47px;
        right: 8px;
        top: 38px;
    }
}

/* Cancel animation*/
.wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
}

/* Css animation */

#Circle {
    stroke-dashoffset: 0;
    stroke-dasharray: 0;
    animation-name: padda;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
}

#Line {
    stroke-dashoffset: 0;
    stroke-dasharray: 0;
    animation-name: padda;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-delay: 1s;
}

@keyframes padda {
    from {
        stroke-dashoffset: 1500;
        stroke-dasharray: 1500;
    }

    to {
        stroke-dashoffset: 0;
        stroke-dasharray: 1500;
    }
}

/* loading animation*/
.container-modal-loding {

    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    align-content: center;
}

.flex {
    min-height: 60pt;
}

@keyframes loading {
    0% {
        width: 50pt;
        height: 50pt;
        margin-top: 0;
    }

    25% {
        height: 4pt;
        margin-top: 23pt;
    }

    50% {
        width: 4pt;
    }

    75% {
        width: 50pt;
    }

    100% {
        width: 50pt;
        height: 50pt;
        margin-top: 0;
    }
}

.loader {
    width: 50pt;
    height: 50pt;
    border-radius: 100%;
    border: #0077B6 4pt solid;
    margin-left: auto;
    margin-right: auto;
    background-color: transparent;
    animation: loading 1s infinite;
}

.load-text {
    padding-top: 15px;
    text-align: center;
    font-size: 22px;
    color: lighten(#5c5cff, 75%);
}`, "",{"version":3,"sources":["webpack://./src/Components/user/operation/Displays.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,iFAAiF;IACjF,kBAAkB;IAClB,0BAA0B;IAC1B,UAAU;IACV,yCAAyC;IACzC,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iFAAiF;IACjF,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,YAAY;IACZ,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;IAaI;AACJ;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,wBAAwB;IACxB,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;;AAExB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;IACd,2CAA2C;AAC/C;;AAEA,qCAAqC;AACrC;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;IACtB,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;;IAEI;;;QAGI,qCAAqC;IACzC;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,mDAAmD;IACvD;AACJ;;;AAGA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,WAAW;;AAEf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;;AAGA;IACI,iFAAiF;IACjF,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,aAAa;IACb,YAAY;IACZ,yCAAyC;IACzC,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,0CAA0C;;AAE9C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,2CAA2C;IAC3C,aAAa;IACb,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,iFAAiF;IACjF,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,UAAU;IACV,yCAAyC;IACzC,UAAU;IACV,YAAY;IACZ,WAAW;IACX,SAAS;AACb;;AAEA;IACI,iFAAiF;IACjF,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,+BAA+B;IAC/B,UAAU;IACV,yCAAyC;IACzC,UAAU;IACV,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,4CAA4C;IAC5C,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iFAAiF;IACjF,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;;IAEb;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;QACvB,yBAAyB;;QAEzB;YACI,QAAQ;YACR,UAAU;YACV,WAAW;YACX,0BAA0B;YAC1B,8BAA8B;QAClC;;QAEA;YACI,MAAM;YACN,UAAU;YACV,WAAW;YACX,uBAAuB;YACvB,8BAA8B;YAC9B,sCAAsC;QAC1C;;QAEA;;YAEI,WAAW;YACX,aAAa;YACb,kBAAkB;YAClB,mBAAmB;YACnB,yBAAyB;QAC7B;;QAEA;YACI,WAAW;YACX,yBAAyB;YACzB,cAAc;YACd,kBAAkB;YAClB,kBAAkB;YAClB,WAAW;;YAEX;gBACI,SAAS;gBACT,UAAU;gBACV,WAAW;gBACX,wBAAwB;gBACxB,8BAA8B;YAClC;;YAEA;gBACI,SAAS;gBACT,UAAU;gBACV,WAAW;gBACX,yBAAyB;gBACzB,+BAA+B;YACnC;QACJ;;QAEA;YACI,SAAS;YACT,UAAU;YACV,WAAW;YACX,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,kBAAkB;YAClB,uBAAuB;YACvB,uCAAuC;QAC3C;;QAEA;YACI,QAAQ;YACR,UAAU;YACV,UAAU;YACV,UAAU;YACV,YAAY;YACZ,kBAAkB;YAClB,yBAAyB;YACzB,yBAAyB;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,SAAS;IACb;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,SAAS;IACb;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,WAAW;QACX,SAAS;IACb;;IAEA;QACI,QAAQ;QACR,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;AACJ;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,kBAAkB;;AAElB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;AACJ;;AAEA,qBAAqB;AACrB;;IAEI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;AAChC","sourcesContent":["body {\r\n    font-family: \"Kanit\";\r\n}\r\n\r\n.refreshButton {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n    text-align: center;\r\n    padding: 2px 10px 0px 10px;\r\n    z-index: 1;\r\n    background-color: rgb(255, 255, 255, 0.8);\r\n    border: 0px;\r\n    border-radius: 8px;\r\n    opacity: 1;\r\n    width: auto;\r\n    height: 30px;\r\n}\r\n\r\n.search-location {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n    display: flex;\r\n    position: absolute;\r\n    text-align: center;\r\n    top: 80px;\r\n    left: 60px;\r\n    padding: 10px;\r\n    z-index: 400;\r\n    background-color: rgb(255, 255, 255, 0.9);\r\n    width: auto;\r\n    height: auto;\r\n    border: 0px;\r\n    border-radius: 24px;\r\n}\r\n\r\n/* .draggable {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n   min-width: 175px;\r\n   height: 400px;\r\n    cursor: grab;\r\n    background-color: #f1f1f1;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    z-index: 400;\r\n    position: absolute;\r\n    border: 0px;\r\n    border-radius: 10px;\r\n } */\r\n.close-button {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 5px;\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 30px;\r\n    color: #868686;\r\n\r\n}\r\n\r\n.close-button:hover {\r\n    color: #0077B6;\r\n    opacity: 0.85;\r\n}\r\n\r\n.bottomBar-main {\r\n    padding: 20px;\r\n    width: 100%;\r\n    height: 45vh;\r\n    background-color: rgb(255, 255, 255, 0.95);\r\n    z-index: 400;\r\n    position: absolute;\r\n    bottom: -10vh;\r\n    /* Define animation */\r\n    animation-name: slideTop;\r\n    animation-duration: 0.7s;\r\n    animation-timing-function: ease-in-out;\r\n}\r\n\r\n.weather-card-container {\r\n    margin: 0px 0px 0px 0px;\r\n    cursor: pointer;\r\n    position: fixed;\r\n    bottom: 10px;\r\n    right: -30px;\r\n    background-color: rgb(255, 255, 255);\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    z-index: 100;\r\n}\r\n\r\n.icon-card-map {\r\n    border: 2px solid rgba(0, 0, 0, 0.4);\r\n    background-clip: padding-box;\r\n    background: #fff;\r\n    border-radius: 5px;\r\n    box-shadow: none;\r\n    cursor: pointer;\r\n    font-family: \"Kanit\";\r\n\r\n}\r\n\r\n.icon-weather {\r\n    width: 44px;\r\n    height: 44px;\r\n    color: #868686;\r\n    transition: 0.5s;\r\n}\r\n\r\n.icon-weather:hover {\r\n    transform: scale(0.8);\r\n    transition: 0.5s;\r\n    color: #0077B6;\r\n    opacity: 0.9;\r\n}\r\n\r\ndiv[class^=\"grid-container-\"] {\r\n    display: grid;\r\n    grid-gap: 1px 10px;\r\n\r\n}\r\n\r\ndiv[class^=\"grid-container-\"] .grid-item {\r\n    padding: 15px 0px;\r\n}\r\n\r\ndiv[class^=\"grid-container-\"] .grid-item:hover {\r\n    background-color: rgba(134, 134, 134, 0.3);\r\n    transition: 0.5s;\r\n}\r\n\r\ndiv.weather {\r\n    text-align: center;\r\n    border-radius: 25px;\r\n    transition: 0.5s;\r\n}\r\n\r\ndiv.weather-selected {\r\n    text-align: center;\r\n    border-radius: 25px;\r\n    background-color: rgba(134, 134, 134, 0.15);\r\n    transition: 0.5s;\r\n}\r\n\r\n.grid-container-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n}\r\n\r\n.grid-container-4 {\r\n    grid-template-columns: repeat(4, 1fr);\r\n}\r\n\r\n.grid-container-5 {\r\n    grid-template-columns: repeat(5, 1fr);\r\n}\r\n\r\n.grid-container-6 {\r\n    grid-template-columns: repeat(6, 15.5%);\r\n}\r\n\r\n.grid-container-7 {\r\n    grid-template-columns: repeat(7, 13%);\r\n}\r\n\r\n.custom-slider-container {\r\n    position: relative;\r\n}\r\n\r\n.custom-slider-container {\r\n    position: relative;\r\n}\r\n\r\n.marks-container {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -5px;\r\n    /* Adjust as needed */\r\n    display: flex;\r\n    margin-left: 10px;\r\n    margin-right: 5px;\r\n    gap: 18px;\r\n}\r\n\r\ndiv[class^=\"compass-arrow-\"] .grid-item {\r\n    padding: 15px 0px;\r\n}\r\n\r\ndiv.compass-container {\r\n    justify-content: center;\r\n    display: flex;\r\n    width: 64px;\r\n    height: 64px;\r\n    padding: 10px 0px;\r\n}\r\n\r\n.compass-arrow {\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n    width: 40px;\r\n    height: 40px;\r\n    color: #0077B6;\r\n    animation: compass-arrow 2s linear infinite;\r\n}\r\n\r\n/* icon static 45deg FaLocationArrow*/\r\n.N {\r\n    --start-angle: -45deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.NNE {\r\n    --start-angle: -22.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.NE {\r\n    --start-angle: 0deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.ENE {\r\n    transform: rotate(22.5deg);\r\n    --start-angle: 22.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.E {\r\n    --start-angle: 45deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.ESE {\r\n    --start-angle: 67.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.SE {\r\n    --start-angle: 90deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.SSE {\r\n    --start-angle: 112.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.S {\r\n    --start-angle: 135deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.SSW {\r\n    --start-angle: 157.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.SW {\r\n    --start-angle: 180deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.WSW {\r\n    --start-angle: 202.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.W {\r\n    --start-angle: 225deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.WSW {\r\n    --start-angle: 247.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.NW {\r\n    --start-angle: 270deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n.NNW {\r\n    --start-angle: 292.5deg;\r\n    animation: move-arrow-compass 6s linear infinite;\r\n}\r\n\r\n@keyframes move-arrow-compass {\r\n\r\n    0%,\r\n    50%,\r\n    100% {\r\n        transform: rotate(var(--start-angle));\r\n    }\r\n\r\n    25% {\r\n        transform: rotate(calc(var(--start-angle) - 10deg));\r\n    }\r\n\r\n    75% {\r\n        transform: rotate(calc(var(--start-angle) + 10deg));\r\n    }\r\n}\r\n\r\n\r\n.dots-container {\r\n    padding: 0;\r\n    position: absolute;\r\n    text-align: center;\r\n    top: 50%;\r\n    width: 100%;\r\n}\r\n\r\n.dots {\r\n    animation: bounce 1.5s infinite linear;\r\n    background: #0077B6;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    height: 15px;\r\n    text-align: center;\r\n    width: 15px;\r\n    margin: 5px;\r\n\r\n}\r\n\r\n.dots:nth-child(1) {\r\n    animation-delay: .2s;\r\n}\r\n\r\n.dots:nth-child(2) {\r\n    animation-delay: .4s;\r\n}\r\n\r\n.dots:nth-child(3) {\r\n    animation-delay: .6s;\r\n}\r\n\r\n.dots:nth-child(4) {\r\n    animation-delay: .8s;\r\n}\r\n\r\n.dots:nth-child(5) {\r\n    animation-delay: 1s;\r\n}\r\n\r\n@keyframes bounce {\r\n    0% {\r\n        transform: translateY(0);\r\n    }\r\n\r\n    15% {\r\n        transform: translateY(-15px);\r\n    }\r\n\r\n    30% {\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n\r\n.search-show-val {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n    display: inline-block;\r\n    position: absolute;\r\n    text-align: start;\r\n    top: 146px;\r\n    left: 60px;\r\n    padding: 10px;\r\n    z-index: 400;\r\n    background-color: rgb(255, 255, 255, 0.9);\r\n    width: 320.5px;\r\n    height: auto;\r\n    border: 0px;\r\n    border-radius: 0px 0px 10px 10px;\r\n}\r\n\r\n.searching-val {\r\n    padding: 3%;\r\n}\r\n\r\n.searching-val:hover {\r\n    opacity: 0.8;\r\n    background-color: rgba(197, 197, 197, 0.8);\r\n    ;\r\n}\r\n\r\n.sidebar-main {\r\n    width: 400px;\r\n    height: 100vh;\r\n    background-color: rgb(255, 255, 255, 0.95);\r\n    z-index: 400;\r\n    position: absolute;\r\n    top: 85px;\r\n    /* Define animation */\r\n    animation-name: slideIn;\r\n    animation-duration: 0.7s;\r\n    animation-timing-function: ease-in-out;\r\n}\r\n\r\n@keyframes slideTop {\r\n    from {\r\n        transform: translateY(50vh);\r\n    }\r\n\r\n    to {\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@keyframes slideIn {\r\n    from {\r\n        transform: translateX(-500px);\r\n    }\r\n\r\n    to {\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n.sidebar-header {\r\n    background-color: rgb(255, 255, 255, 0.95);\r\n    padding: 5% 5% 5px 5%;\r\n    display: flex;\r\n    text-align: center;\r\n    width: 100%;\r\n    color: #0077B6;\r\n    border-bottom: 2px solid #555;\r\n}\r\n\r\n.sidebar-section {\r\n\r\n    border-top: 2px solid rgb(0, 150, 199, 0.4);\r\n    display: flex;\r\n    justify-items: center;\r\n}\r\n\r\n\r\n.icon-pointer {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: auto;\r\n}\r\n\r\n.icon-pointer:hover {\r\n    cursor: pointer;\r\n    opacity: 0.7;\r\n}\r\n\r\n.search-input {\r\n    height: 30px;\r\n    margin: auto;\r\n    margin-left: 15px;\r\n    border: none;\r\n    background-color: rgba(255, 255, 255, 0.7);\r\n    border-radius: 15px;\r\n    padding: 5px 10px 5px 15px;\r\n}\r\n\r\n.search-input:hover {\r\n    background-color: rgb(0, 150, 199, 0.4)\r\n}\r\n\r\n.search-input:focus {\r\n    outline: none;\r\n    background-color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.toNav-btn {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n    position: absolute;\r\n    text-align: center;\r\n    align-items: center;\r\n    padding: 2px 10px 0px 10px;\r\n    z-index: 1;\r\n    background-color: rgb(255, 255, 255, 0.9);\r\n    opacity: 1;\r\n    height: 20px;\r\n    width: 60px;\r\n    left: 50%;\r\n}\r\n\r\n.toNavSide-btn {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n    position: absolute;\r\n    text-align: end;\r\n    align-items: center;\r\n    /* padding:2px 10px 0px 10px; */\r\n    z-index: 1;\r\n    background-color: rgb(255, 255, 255, 0.9);\r\n    opacity: 1;\r\n    height: 70px;\r\n    width: 25px;\r\n    /* Define animation */\r\n    animation-name: slideIn;\r\n    animation-duration: 0.7s;\r\n    animation-timing-function: ease-in-out;\r\n}\r\n\r\n.sidebar-date-box {\r\n    background-color: white;\r\n    border-radius: 2%;\r\n    width: 350px;\r\n}\r\n\r\n.sidebar-wrapper {\r\n    display: flex;\r\n    justify-items: center;\r\n    padding: 3% 1%;\r\n    margin: auto;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.sidebar-card {\r\n    margin-left: 5px;\r\n    vertical-align: baseline;\r\n    width: 380px;\r\n    height: auto;\r\n    max-width: 380px;\r\n    padding: 20px 15px;\r\n    min-inline-size: auto;\r\n    background-color: rgba(216, 216, 216, 0.658);\r\n    border-radius: 10px;\r\n    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.sidebar-card-title {\r\n    position: relative;\r\n}\r\n\r\n.sidebar-card-body {\r\n    height: auto;\r\n    overflow: auto;\r\n}\r\n\r\n.sidebox-remark {\r\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\r\n    display: flex;\r\n    position: absolute;\r\n    text-align: center;\r\n    margin-top: 15px;\r\n    left: 430px;\r\n    width: 500px;\r\n    height: auto;\r\n    padding: 20px 15px;\r\n    min-inline-size: auto;\r\n    background-color: rgba(216, 216, 216, 0.92);\r\n    border-radius: 6px;\r\n    box-shadow: 0px 4px 7px 1px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.remark-details {\r\n    text-align: start;\r\n}\r\n\r\n.close-btn {\r\n    cursor: pointer;\r\n    float: left;\r\n    font-size: 20px;\r\n}\r\n\r\n.selection-Date {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.selection-Time {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    margin: 15px 0px;\r\n}\r\n\r\np.datafeatures {\r\n    cursor: pointer;\r\n}\r\n\r\np.datafeatures:hover {\r\n    color: gray;\r\n}\r\n\r\np.datafeatures:focus {\r\n    color: #0077B6;\r\n}\r\n\r\n.leaflet-popup-content {\r\n    text-align: start;\r\n    font-size: 12.5px;\r\n}\r\n\r\n.leaflet-popup-tip {\r\n    display: none;\r\n}\r\n\r\n#latlonSelect {\r\n    color: \"red\";\r\n}\r\n\r\n.nav-link-test {\r\n    padding: 0 !important;\r\n}\r\n\r\n.custom-nav-dropdown .dropdown-menu {\r\n    padding: 0;\r\n}\r\n\r\n.custom-nav-dropdown .nav-link {\r\n    padding: 0;\r\n}\r\n\r\n/* btn image CheckMark animation */\r\n.success-checkmark {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 150px;\r\n\r\n    .check-icon {\r\n        width: 80px;\r\n        height: 80px;\r\n        position: relative;\r\n        border-radius: 50%;\r\n        box-sizing: content-box;\r\n        border: 4px solid #4CAF50;\r\n\r\n        &::before {\r\n            top: 3px;\r\n            left: -2px;\r\n            width: 30px;\r\n            transform-origin: 100% 50%;\r\n            border-radius: 100px 0 0 100px;\r\n        }\r\n\r\n        &::after {\r\n            top: 0;\r\n            left: 30px;\r\n            width: 60px;\r\n            transform-origin: 0 50%;\r\n            border-radius: 0 100px 100px 0;\r\n            animation: rotate-circle 4.25s ease-in;\r\n        }\r\n\r\n        &::before,\r\n        &::after {\r\n            content: '';\r\n            height: 100px;\r\n            position: absolute;\r\n            background: #FFFFFF;\r\n            transform: rotate(-45deg);\r\n        }\r\n\r\n        .icon-line {\r\n            height: 5px;\r\n            background-color: #4CAF50;\r\n            display: block;\r\n            border-radius: 2px;\r\n            position: absolute;\r\n            z-index: 10;\r\n\r\n            &.line-tip {\r\n                top: 46px;\r\n                left: 14px;\r\n                width: 25px;\r\n                transform: rotate(45deg);\r\n                animation: icon-line-tip 0.75s;\r\n            }\r\n\r\n            &.line-long {\r\n                top: 38px;\r\n                right: 8px;\r\n                width: 47px;\r\n                transform: rotate(-45deg);\r\n                animation: icon-line-long 0.75s;\r\n            }\r\n        }\r\n\r\n        .icon-circle {\r\n            top: -4px;\r\n            left: -4px;\r\n            z-index: 10;\r\n            width: 80px;\r\n            height: 80px;\r\n            border-radius: 50%;\r\n            position: absolute;\r\n            box-sizing: content-box;\r\n            border: 4px solid rgba(76, 175, 80, .5);\r\n        }\r\n\r\n        .icon-fix {\r\n            top: 8px;\r\n            width: 5px;\r\n            left: 26px;\r\n            z-index: 1;\r\n            height: 85px;\r\n            position: absolute;\r\n            transform: rotate(-45deg);\r\n            background-color: #FFFFFF;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes rotate-circle {\r\n    0% {\r\n        transform: rotate(-45deg);\r\n    }\r\n\r\n    5% {\r\n        transform: rotate(-45deg);\r\n    }\r\n\r\n    12% {\r\n        transform: rotate(-405deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(-405deg);\r\n    }\r\n}\r\n\r\n@keyframes icon-line-tip {\r\n    0% {\r\n        width: 0;\r\n        left: 1px;\r\n        top: 19px;\r\n    }\r\n\r\n    54% {\r\n        width: 0;\r\n        left: 1px;\r\n        top: 19px;\r\n    }\r\n\r\n    70% {\r\n        width: 50px;\r\n        left: -8px;\r\n        top: 37px;\r\n    }\r\n\r\n    84% {\r\n        width: 17px;\r\n        left: 21px;\r\n        top: 48px;\r\n    }\r\n\r\n    100% {\r\n        width: 25px;\r\n        left: 14px;\r\n        top: 45px;\r\n    }\r\n}\r\n\r\n@keyframes icon-line-long {\r\n    0% {\r\n        width: 0;\r\n        right: 46px;\r\n        top: 54px;\r\n    }\r\n\r\n    65% {\r\n        width: 0;\r\n        right: 46px;\r\n        top: 54px;\r\n    }\r\n\r\n    84% {\r\n        width: 55px;\r\n        right: 0px;\r\n        top: 35px;\r\n    }\r\n\r\n    100% {\r\n        width: 47px;\r\n        right: 8px;\r\n        top: 38px;\r\n    }\r\n}\r\n\r\n/* Cancel animation*/\r\n.wrap {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 150px;\r\n}\r\n\r\n/* Css animation */\r\n\r\n#Circle {\r\n    stroke-dashoffset: 0;\r\n    stroke-dasharray: 0;\r\n    animation-name: padda;\r\n    animation-duration: 2s;\r\n    animation-timing-function: ease-in-out;\r\n}\r\n\r\n#Line {\r\n    stroke-dashoffset: 0;\r\n    stroke-dasharray: 0;\r\n    animation-name: padda;\r\n    animation-duration: 2s;\r\n    animation-timing-function: ease-in-out;\r\n    animation-delay: 1s;\r\n}\r\n\r\n@keyframes padda {\r\n    from {\r\n        stroke-dashoffset: 1500;\r\n        stroke-dasharray: 1500;\r\n    }\r\n\r\n    to {\r\n        stroke-dashoffset: 0;\r\n        stroke-dasharray: 1500;\r\n    }\r\n}\r\n\r\n/* loading animation*/\r\n.container-modal-loding {\r\n\r\n    background: #ffffff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    justify-content: center;\r\n    align-content: center;\r\n}\r\n\r\n.flex {\r\n    min-height: 60pt;\r\n}\r\n\r\n@keyframes loading {\r\n    0% {\r\n        width: 50pt;\r\n        height: 50pt;\r\n        margin-top: 0;\r\n    }\r\n\r\n    25% {\r\n        height: 4pt;\r\n        margin-top: 23pt;\r\n    }\r\n\r\n    50% {\r\n        width: 4pt;\r\n    }\r\n\r\n    75% {\r\n        width: 50pt;\r\n    }\r\n\r\n    100% {\r\n        width: 50pt;\r\n        height: 50pt;\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n.loader {\r\n    width: 50pt;\r\n    height: 50pt;\r\n    border-radius: 100%;\r\n    border: #0077B6 4pt solid;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    background-color: transparent;\r\n    animation: loading 1s infinite;\r\n}\r\n\r\n.load-text {\r\n    padding-top: 15px;\r\n    text-align: center;\r\n    font-size: 22px;\r\n    color: lighten(#5c5cff, 75%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
